import { render } from "./RegistartionActivate.vue?vue&type=template&id=55d3d753&scoped=true"
import script from "./RegistartionActivate.vue?vue&type=script&lang=js"
export * from "./RegistartionActivate.vue?vue&type=script&lang=js"

import "./RegistartionActivate.vue?vue&type=style&index=0&id=55d3d753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d3d753"]])

export default __exports__